<mc-loading [overlay]="true" *ngIf="loading"></mc-loading>
<div class="col-12 d-flex flex-column justify-content-between px-0">
    <p class="m-0 title">{{ 'app.global.modals.image_manager.upload_image_modal.link.title' | translate }}</p>
    <form [formGroup]="urls" class="image-url-form scroll-y-auto pr-3">
        <ng-container *ngFor="let item of urls.controls; let i = index">
            <div class="input-group">
                <div class="input-social-group col-12 d-flex align-items-center justify-content-between p-0">
                    <input
                        class="form-control input-social-group-link w-100 pr-5"
                        [ngClass]="
                            item.value
                                ? item.valid
                                    ? 'social-input-checked'
                                    : 'social-input-denied'
                                : !item.pristine
                                ? item.value
                                    ? item.valid
                                        ? 'social-input-checked'
                                        : 'social-input-denied'
                                    : ''
                                : ''
                        "
                        type="text"
                        [formControlName]="i"
                        label="Url"
                        #inputElement
                        placeholder="{{ 'app.global.modals.image_manager.upload_image_modal.link.label' | translate }}"
                    />
                    <i
                        class="input-social-group-validation-icon"
                        [ngClass]="
                            item.value
                                ? item.valid
                                    ? 'fal fa-check-circle social-checked'
                                    : 'fal fa-times-circle social-denied'
                                : !item.pristine
                                ? item.value
                                    ? item.valid
                                        ? 'fal fa-check-circle social-checked'
                                        : 'fal fa-times-circle social-denied'
                                    : ''
                                : ''
                        "
                    ></i>
                    <span>
                        <i
                            class="fal fa-trash ml-2 social-trash ml-2"
                            (click)="deleteUrlField(i)"
                            [style.color]="i === 0 && urls.controls.length <= 1 ? '#bdbdbd' : '#666'"
                            [style.cursor]="i === 0 && urls.controls.length <= 1 ? 'default' : 'pointer'"
                        ></i>
                    </span>
                </div>
                <div class="invalid-tooltip" *ngIf="item.errors">
                    <small *ngIf="item.errors.url">{{
                        'app.global.modals.image_manager.upload_image_modal.link.errors.invalid' | translate
                    }}</small>
                    <small *ngIf="item.errors.required">{{
                        'app.global.modals.image_manager.upload_image_modal.link.errors.field_validation' | translate
                    }}</small>
                </div>
            </div>
        </ng-container>
    </form>
    <div class="w-100 d-flex justify-content-end pb-3 pr-3">
        <span
            (click)="addField()"
            [ngClass]="
                urls.controls[0].value
                    ? urls.status == 'VALID'
                        ? 'color-link add-social-link'
                        : urls.dirty && urls.controls[0].value
                        ? 'color-link-disabled'
                        : 'color-link-disabled'
                    : 'color-link-disabled'
            "
            class="m-0"
        >
            + {{ 'app.global.modals.image_manager.upload_image_modal.link.add_url' | translate }}
        </span>
    </div>
</div>
<div class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4 pr-3 buttons-url">
    <button class="btn btn-skip mr-3" mat-dialog-close (click)="cancel()">
        {{ 'app.global.modals.image_manager.upload_image_modal.link.buttons.cancel' | translate }}
    </button>
    <button (click)="save()" [disabled]="urlsForm.value.urls[0] === '' || !urlsForm.valid" class="btn btn-continue">
        {{ 'app.global.modals.image_manager.upload_image_modal.link.buttons.save' | translate }}
    </button>
</div>
